var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "translate(3, 5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.32743C0 0.594309 0.558191 0 1.24675 0H12.4675C13.1561 0 13.7143 0.594308 13.7143 1.32743V9.95569C13.7143 10.6888 13.1561 11.2831 12.4675 11.2831H1.24675C0.558191 11.2831 0 10.6888 0 9.95569V1.32743ZM12.4675 1.32743H1.24675V9.95569H12.4675V1.32743Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28577 3.89887C4.28577 3.16575 4.84396 2.57144 5.53252 2.57144H16.7533C17.4419 2.57144 18.0001 3.16575 18.0001 3.89887V12.5271C18.0001 13.2602 17.4419 13.8546 16.7533 13.8546H5.53252C4.84396 13.8546 4.28577 13.2602 4.28577 12.5271V3.89887ZM16.7533 3.89887H5.53252V12.5271H16.7533V3.89887Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClock);
export default __webpack_public_path__ + "static/media/alarmClock.d92b9a18438eede1d210ccdb93087770.svg";
export { ForwardRef as ReactComponent };